var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25V13.75C15 17.15 14.125 18 10.625 18H5.375C1.875 18 1 17.15 1 13.75V5.25C1 1.85 1.875 1 5.375 1H10.625C14.125 1 15 1.85 15 5.25Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.97501H6.25",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00078 15.535C8.74982 15.535 9.35703 14.9451 9.35703 14.2175C9.35703 13.4899 8.74982 12.9 8.00078 12.9C7.25175 12.9 6.64453 13.4899 6.64453 14.2175C6.64453 14.9451 7.25175 15.535 8.00078 15.535Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.fb8770f4520651ae007926f847df13cb.svg";
export { ForwardRef as ReactComponent };